import BaseApi from './baseAPI'

class ChatAPI extends BaseApi{

  get entity() {
    return {
      route: `/chat`,
      name: 'محادثة'
    }
  }

  loadMoreMessages(id, data = null){
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.entity.route}/${id}`, data)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  markAllSeen(id){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${id}/seen`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new ChatAPI()
